import { mapSingleValue } from "helpers";
import { Predicates } from "libraries/predicates/predicates";
import { ItemNumberSearchesState } from "states/item-number-searches/data.type";
import { retrieveObjectFromLocalStorage } from "./local-storage.helper";
import {
  SearchItemNumberPersistentData,
} from "types/persistent-page-filters";

export const buildItemNumberSearchFilterObject = (state: ItemNumberSearchesState) => {
  return {
    itn_itemno: state.itn_itemno ? state.itn_itemno.toString() : null,
    itn_itemnm: state.itn_itemnm ? state.itn_itemnm.toString() : null,
    global_product_id: Predicates.isNotNullAndNotUndefined(state.newGlobalProduct)
      ? (state.newGlobalProduct.id ?? "").toString()
      : null,
    category: state.category ? state.category.id.toString() : null,
    sub_category: state.subCategory ? state.subCategory.id.toString() : null,
    product_line: state.productLine ? state.productLine.id.toString() : null,
    itn_cptype: state.itn_cptype ? state.itn_cptype.toString() : null,
    itn_cplang: state.itn_cplang ? state.itn_cplang.toString() : null,
    itn_cpgcod: state.itn_cpgcod ? state.itn_cpgcod.toString() : null,
    itn_cpgnam: state.itn_cpgnam
      ? state.itn_cpgnam.toString()
      : null,

    itn_inclfm: state.itn_inclfm
      ? state.itn_inclfm.value.toString()
      : null,
    itn_lfmnum: state.itn_lfmnum
      ? state.itn_lfmnum
      : null,
    itn_lifsts: mapSingleValue(state.itn_lifsts),
    itn_lfmnam: state.itn_lfmnam
      ? state.itn_lfmnam
      : null,
    itn_plgtyp: !!state?.itn_plgtyp?.id ? state?.itn_plgtyp?.id.toString() : null,
    itn_plgnam: state.itn_plgnam
      ? state.itn_plgnam.toString()
      : null,
    itn_restri: state.itn_restri ? state.itn_restri.toString() : null,
    itn_ean13d: state.itn_ean13d ? state.itn_ean13d.toString() : null,
    itn_upc12d: state.itn_upc12d ? state.itn_upc12d.toString() : null,
    itn_mfpnum: state.itn_mfpnum
      ? state.itn_mfpnum.toString()
      : null,
    itn_relsdt: state.itn_relsdt ? state.itn_relsdt.toString() : null,
    marketing_material: state.marketing_material_id?.id.toString() ?? null

  };
};

// export const buildItemNumberRequestSearchFilterObject = (state: ItemNumberSearchesState) => {
//   return {
//     id: state.requestId ? state.requestId : null,
//     status__status: state.requestStatus ? state.requestStatus.value : null,
//     created_at__gte: state.requestDateFrom ? state.requestDateFrom : null,
//     created_at__lte: state.requestDateTo ? state.requestDateTo : null,
//     created_by__id: state.requestor ? state.requestor : null,
//     approved_date__gte: state.approvedDateFrom ? state.approvedDateFrom : null,
//     approved_date__lte: state.approvedDateTo ? state.approvedDateTo : null,
//     approver: state.approver ? state.approver : null,
//     tcc__id: Predicates.isNotNullAndNotUndefined(state.tcc)
//       ? (state.tcc.id ?? "").toString()
//       : null,
//     global_product__id: Predicates.isNotNullAndNotUndefined(state.globalProduct)
//       ? (state.globalProduct.id ?? "").toString()
//       : null,
//     category__id: state.category ? state.category.id.toString() : null,
//     sub_category__id: state.subCategory
//       ? state.subCategory.id.toString()
//       : null,
//     product_line__id: state.productLine
//       ? state.productLine.id.toString()
//       : null,
//     product_color__id: state.productColor
//       ? state.productColor.id.toString()
//       : null,
//     marketing_material__id: state.marketingMaterial
//       ? state.marketingMaterial.id?.toString()
//       : null,
//     decoration_technique__id: state.decoTech
//       ? state.decoTech.id.toString()
//       : null,
//     artworkCollection__id: state.artworkCollection
//       ? state.artworkCollection?.id?.toString()
//       : null,
//     masterArtwork__id: state.masterArtwork
//       ? state.masterArtwork?.id?.toString()
//       : null,    
//     artwork__id: state.artwork ? state.artwork.unique_id.toString() : null,
//     channel__id: state.channel ? state.channel.id?.toString() : null,
//     [state.piecesSellingUnitsOperator.value]: state.piecesSellingUnits
//       ? state.piecesSellingUnits
//       : null,
//     consumer_facing_name: state.consumerFacingName
//       ? state.consumerFacingName
//       : null,
//     royalty_item: state.royaltyItem
//       ? state.royaltyItem.value === "1"
//         ? [true]
//         : [false]
//       : null,
//     licensor__id: state.licensor ? state.licensor.id?.toString() : null,
//     licensed_property__id: state.licensedProperty
//       ? state.licensedProperty.id?.toString()
//       : null,
//     flavor_scent__id: state.flavorScent
//       ? state.flavorScent.id?.toString()
//       : null,
//     active_global_tcc: state.active_global_tcc
//     ? state.active_global_tcc.value === "1"
//       ? [true]
//       : [false]
//     : null,
//   };
// };

export const getOperatorAndValue = (storedFilters: any, keyPrefix: string) => {
  for (let key in storedFilters) {
    if (key.includes(keyPrefix)) {
      const releaseDateKeySplit = key.split("__");
      let label = "";
      switch (releaseDateKeySplit[1]) {
        case "gt":
          label = ">";
          break;
        case "gte":
          label = ">=";
          break;
        case "lt":
          label = "<";
          break;
        case "lte":
          label = "<=";
          break;
        default:
          label = "=";
          break;
      }
      return {
        operator: { label: label, value: key },
        value: storedFilters[key] ?? "",
      };
    }
  }
};

// export const buildItemNumberRequestTextFiltersBasedOnLocalStorage = (
//   prefix:
//     | SearchItemNumberPersistentData["prefix"]
// ): Partial<ItemNumberSearchesState> => {
//   const storedFilters = retrieveObjectFromLocalStorage<
//     SearchItemNumberPersistentData
//   >(prefix, "lastFilters");
//   if (storedFilters) {
//     const piecesSellingUnitsValues = getOperatorAndValue(
//       storedFilters,
//       "pieces_selling_units",
//     );
//     return {
//       piecesSellingUnitsOperator: piecesSellingUnitsValues?.operator ?? {
//         value: "pieces_selling_units",
//         label: "=",
//       },
//       piecesSellingUnits: piecesSellingUnitsValues?.value ?? "",
//       consumerFacingName: storedFilters.consumer_facing_name ?? "",
//       requestDateFrom: storedFilters.created_at__gte ?? "",
//       requestDateTo: storedFilters.created_at__lte ?? "",
//       requestor: storedFilters.created_by__id ?? "",
//       approver: storedFilters.approver ?? "",
//       approvedDateFrom: storedFilters.approved_date__gte ?? "",
//       approvedDateTo: storedFilters.approved_date__lte ?? "",
//       requestId: storedFilters.id ?? "",
//     };
//   } else {
//     return {};
//   }
// };

// export const buildItemNumberTextFiltersBasedOnLocalStorage = (
//   prefix:
//     | SearchItemNumberPersistentData["prefix"]
// ): Partial<ItemNumberSearchesState> => {
//   const storedFilters = retrieveObjectFromLocalStorage<
//     SearchItemNumberPersistentData
//   >(prefix, "lastFilters");
//   if (storedFilters) {
//     const piecesSellingUnitsValues = getOperatorAndValue(
//       storedFilters,
//       "pieces_selling_units",
//     );
//     return {
//       piecesSellingUnitsOperator: piecesSellingUnitsValues?.operator ?? {
//         value: "pieces_selling_units",
//         label: "=",
//       },
//       piecesSellingUnits: piecesSellingUnitsValues?.value ?? "",
//       itemNumber: storedFilters.item_number ?? "",
//       consumerFacingName: storedFilters.consumer_facing_name ?? "",
//       requestDateFrom: storedFilters.requestDate_gt ?? "",
//       requestDateTo: storedFilters.requestDate_lt ?? "",
//       requestor: storedFilters.requestor ?? "",
//       approver: storedFilters.approver ?? "",
//       approvedDateFrom: storedFilters.approvedDate_gt ?? "",
//       approvedDateTo: storedFilters.approvedDate_lt ?? "",
//       globalStandardCost: storedFilters.global_standard_cost ?? "",
//       globalMsrp: storedFilters.global_manufacturer_price ?? "",
//     };
//   } else {
//     return {};
//   }
// };

export const buildDropdownFiltersBasedOnLocalStorage = (
  prefix:
    | SearchItemNumberPersistentData["prefix"]
): Partial<ItemNumberSearchesState> => {
  const storedDropdownFilters = retrieveObjectFromLocalStorage<
    SearchItemNumberPersistentData
  >(prefix, "lastDropdownFilters");
  if (storedDropdownFilters) {
    return {
      newGlobalProduct: storedDropdownFilters.globalProduct ?? null,
      category: storedDropdownFilters.category ?? null,
      subCategory: storedDropdownFilters.subCategory ?? null,
      productLine: storedDropdownFilters.productLine ?? null,
      itn_itemno: storedDropdownFilters.itn_itemno ?? null,
      itn_itemnm: storedDropdownFilters.itn_itemnm ?? null,
      itn_reqmkt: storedDropdownFilters.marketingMaterial ?? null,
      itn_cptype: storedDropdownFilters.itn_cptype ?? null,
      itn_cplang: storedDropdownFilters.itn_cplang ?? null,
      itn_cpgcod: storedDropdownFilters.itn_cpgcod ?? null,
      itn_cpgnam: storedDropdownFilters.itn_cpgnam ?? null,
      itn_inclfm: storedDropdownFilters.itn_inclfm ?? null,
      itn_lfmnum: storedDropdownFilters.itn_lfmnum ?? null,
      itn_lfmnam: storedDropdownFilters.itn_lfmnam ?? null,
      itn_plgtyp: storedDropdownFilters.itn_plgtyp ?? null,
      itn_plgnam: storedDropdownFilters.itn_plgnam ?? null,
      itn_restri: storedDropdownFilters.itn_restri ?? null,
      itn_lifsts: storedDropdownFilters.itn_lifsts ?? null,
      itn_ean13d: storedDropdownFilters.itn_ean13d ?? null,
      itn_upc12d: storedDropdownFilters.itn_upc12d ?? null,
      itn_mfpnum: storedDropdownFilters.itn_mfpnum ?? null,

    };
  } else {
    return {};
  }
};
